import React, { useEffect, useMemo } from "react";
import Select from "components/ui/Select";
import { useAllHsn } from "http-hooks/hsn/useHsn";

const SelectHsn = ({
  value,
  onChange,
  placeholder = "Search HSN / SAC...",
  isDisabled = false,
  isRequired = false,
  label = "HSN / SAC",
  className = "",
  filters = {},
  showLabel = true,
}) => {
  const {
    isLoading: isLoadingAllHsn,
    data: allHsn = [],
  } = useAllHsn(filters);

  // Convert HSN/SAC records to options for Select component
  const hsnOptions = useMemo(() => {
    return allHsn?.map(hsn => ({
      value: hsn.hid,
      label: `${hsn.code_type || "HSN"}: ${hsn.hsncode}`,
      hsncode: hsn.hsncode,
      ...hsn
    })) || [];
  }, [allHsn]);

  // Auto-select the matching option when HSNs load and value is provided as simple object
  useEffect(() => {
    // If value is provided as a simple object with hsncode but not as a full option
    if (value && !value.value && value.hsncode && hsnOptions.length > 0 && onChange) {
      const matchedOption = hsnOptions.find(option => 
        String(option.hsncode) === String(value.hsncode)
      );
      
      if (matchedOption && matchedOption !== value) {
        onChange(matchedOption);
      }
    }
  }, [value, hsnOptions, onChange]);

  return (
    <Select
      value={value}
      onChange={onChange}
      options={hsnOptions}
      getOptionValue={(option) => option?.value}
      getOptionLabel={(option) => option?.label}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isLoading={isLoadingAllHsn}
      isRequired={isRequired}
      label={label}
      className={className}
      showLabel={showLabel}
      isClearable={true}
      isSearchable={true}
    />
  );
};

export default SelectHsn; 